import React from 'react';
import { Modal, ModalHeader, ModalFooter, ModalBody, Label, Input } from 'reactstrap';
import { Dots } from "react-activity";

const NewActivityModal = ({
  setActivityDescription,
  submit,
  toggle,
  activityDescription,
  loading,
  isOpen,
}) => {

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      className='crm-modal-gestion-container crm-modal-new-gestion'
    >
      <ModalHeader toggle={toggle}>
        Nueva Actividad
        <div className="af-gold-line" />
      </ModalHeader>
      <form onSubmit={submit}>
        <ModalBody>
          <div className="crm-modal-form-group-textarea">
            <div className="crm-modal-input-group">
              <Label id='new-activity'>Ingrese Nueva Actividad</Label>
              <Input
                id='new-activity'
                className='crm-modal-input-textarea'
                type='textarea'
                value={activityDescription}
                onChange={(e) => setActivityDescription(e.target.value)}
                disabled={loading}
                maxLength='500'
                required
              />
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <button
            className="crm-modal-cancel-btn"
            type="button"
            onClick={toggle}
            disabled={loading}
          >
            Cancelar
          </button>
          <button
            className="crm-modal-accept-btn"
            type="submit"
            disabled={loading}
          >
            {loading ? <Dots /> : 'Agregar Actividad'}
          </button>
        </ModalFooter>
      </form>
    </Modal>
  );
}

export default NewActivityModal;